var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner"},[_c('div',{staticClass:"banner__background",style:({ backgroundImage: `url(${_vm.buyingPowerBanner})` })}),_c('div',{staticClass:"banner__text"},[_c('new-l-heading',{attrs:{"tag":"h1","weight":"bold"}},[_vm._v("\n      Descubra o valor do imóvel que cabe no seu bolso\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }